import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "@/router";
import './plugins'
import store from "@/store";
import i18n from "@/plugins/i18n";

Vue.config.productionTip = false
sync(store, router)

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
